import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, Link, Typography, useTheme } from '@mui/material'
import { EventType } from '@/features/events/shared/types'
import { ToolHeader } from '../shared'

interface WebFetchContextRendererProps {
  readonly url: string
  readonly prompt: string
}

export const WebFetchContextRenderer: FC<WebFetchContextRendererProps> = ({ url, prompt }) => {
  const theme = useTheme()

  return (
    <>
      <ToolHeader eventType={EventType.TOOL_PERMISSION_REQUEST} toolName="WebFetch" />

      <Box sx={promptContainerSx}>
        <Typography variant="body2" sx={promptValueSx(theme)}>
          &quot;{prompt}&quot;
        </Typography>
      </Box>

      <Box sx={urlContainerSx}>
        <Link href={url} target="_blank" rel="noopener noreferrer" underline="hover" sx={urlLinkSx}>
          {url}
        </Link>
      </Box>
    </>
  )
}

const promptContainerSx: SxProps<Theme> = {
  mt: 1,
  mb: 1.5,
}

const urlContainerSx: SxProps<Theme> = {
  mt: 1,
}

const urlLinkSx: SxProps<Theme> = {
  fontFamily: 'monospace',
  wordBreak: 'break-all',
  fontSize: 'inherit',
}

const promptValueSx = (theme: Theme): SxProps<Theme> => ({
  fontStyle: 'italic',
  color: theme.palette.text.secondary,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  fontSize: 'inherit',
})
